export default __webpack_public_path__ + "static/media/step-two-extractor.4f5b896d.jpg";